<template>
  <div class="content-body">
    <div class="d-flex justify-content-between align-items-center w-100 mb-2">
      <h2 class="content-header-title" style="border-right: none;">{{project.short_name}} ⇝ Шаблоны документов</h2>
      <button class="compose btn btn-primary" @click="newRecord()">Добавить</button>
    </div>

    <div class="card">
      <div class="card-header p-0">
        <div class="d-flex justify-content-between w-100">
          <div class="input-group input-group-merge shadow-none m-0 flex-grow-1">
            <div class="input-group-prepend">
              <span class="input-group-text border-0">
                <font-awesome-icon icon="fas fa-search" />
              </span>
            </div>
            <input type="text" @input="search()" v-model="searchQuery" class="form-control files-filter border-0 bg-transparent" placeholder="Поиск" />
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body h-100" style="padding: 0;">
        <div class="table-striped">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 5%;">#</th>
                <th style="width: 40%;">Наименование</th>
                <th style="width: 20%;">Каталог</th>
                <th style="width: 20%;">Описание</th>
                <th style="width: 15%;">Действия</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="templates.length > 0">
                <tr v-for="(template, index) in templates">
                  <td>{{index + 1}}</td>
                  <td>{{template.name}}</td>
                  <td>
                    <p v-if="template.folder">{{template.folder.name}}</p>
                  </td>
                  <td>{{template.description}}</td>
                  <td>
                    <div class="btn-group">
                      <a class="btn btn-sm btn-success" v-if="template.file" @click.prevent="viewRecord(template)" href="#"><font-awesome-icon icon="fas fa-eye" /></a>
                      <a class="btn btn-sm btn-primary" @click.prevent="editRecord(template)" href="#"><font-awesome-icon icon="fas fa-edit" /></a>
                      <a class="btn btn-sm btn-danger" @click.prevent="deleteRecord(template.id)" href="#"><font-awesome-icon icon="fas fa-trash" /></a>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="4">
                    Нет данных для отображения
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <nav class="justify-content-between d-flex mt-2 align-items-center">
          <div class="p-2">
            <label for="inputState" class="form-label mb-0">На странице: </label>
            <select class="form-select" v-model="perPage" @change="changePerPage()">
              <option :value="value" v-for="value in perPageList">{{value}}</option>
            </select>
          </div>
          <ul class="pagination mb-0">
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(firstPage)" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-fast-backward" /> Первая
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="prevPage()" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-step-backward" /> Предыдущая
              </a>
            </li>
            <li class="page-item" :class="{ 'active': page.active }" v-for="page in visiblePages">
              <a class="page-link" @click.prevent="selectPage(page.name)" href="#">{{page.name}}</a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="nextPage()" href="#">
                Следующая <font-awesome-icon class="ml-1" icon="fas fa-step-forward" />
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(lastPage)" href="#">
                Последняя <font-awesome-icon class="ml-1" icon="fas fa-fast-forward" />
              </a>
            </li>
          </ul>
          <div class="p-2">
            <p class="mb-0">(Всего страниц: {{lastPage}})</p>
          </div>
        </nav>

      </div>
    </div>

    <!-- Field Add/Edit Modal -->
    <div class="modal modal-slide-in fade" id="addNewRecord" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content pt-0">
        <div class="modal-header mb-1">
          <h5 class="modal-title" v-show="!editmode">Добавить</h5>
          <h5 class="modal-title" v-show="editmode">Редактировать</h5>
        </div>
        <form @submit.prevent="editmode ? updateRecord() : createRecord()">
            <div class="modal-body">
              <div class="form-group">
                <label>Наименование</label>
                <input v-model="recordform.name" type="text" placeholder="Наименование" class="form-control" required>
              </div>
              <div class="form-group">
                <label>Описание</label>
                <input v-model="recordform.description" type="text" placeholder="Описание" class="form-control">
              </div>


              <label>Файл (в формате .docx или .pdf)</label>
              <div class="input-group" v-if="changefile">
                <input type="file" :key="fileInputKey" @change="fileUpload" accept=".docx, .pdf"  class="form-control" style="border: 0;" />
                <div v-if="changefile && editmode" class="input-group-append">
                  <button @click="changefile = !changefile" class="btn btn-outline-primary waves-effect" type="button">Отмена</button>
                </div>
              </div>
              <div class="input-group" v-if="editmode && !changefile">
                <input v-model="recordform.file" disabled type="text" name="number" class="form-control">
                <div v-if="!changefile" class="input-group-append">
                  <button @click="changefile = !changefile" class="btn btn-outline-primary waves-effect" type="button"><font-awesome-icon icon="fas fa-edit" /></button>
                </div>
              </div>

              <div class="form-group">
                <label>Выберите каталог</label>
                <treeselect v-model="recordform.folder_id" :multiple="false" :defaultExpandLevel="3" :options="filteredRecords">
                  <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                    {{ node.raw.name }}
                    <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                  </label>

                  <div slot="value-label" slot-scope="{ node }">{{ node.raw.name }}</div>
                </treeselect>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
              <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
              <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Field Add/Edit Modal -->

    <!-- Modal Show Result -->
    <div class="modal fade" id="showPDFModal" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
      <div class="modal-dialog modal-xl" style="max-width: 95%; height: 95vh;">
        <div class="modal-content h-100 p-0">
          <embed :src="'/pdf/template/'+link" :key="link_path" class="h-100 w-100" type='application/pdf'>
        </div>
      </div>
    </div>
    <!-- !Modal Show Result -->

    <!-- OnlyOffice Modal прямо в основном компоненте -->
    <div class="modal fade" id="onlyOfficeModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-xl" style="max-width: 95%; height: 95vh;">
        <div class="modal-content h-100 p-0">
          <div class="modal-header">
            <h5 class="modal-title">Редактирование: {{ onlyOfficeTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0" style="height: calc(100% - 120px);">
            <iframe
              v-if="currentTemplate"
              :key="onlyOfficeKey"
              class="onlyoffice-editor"
              frameborder="0"
              style="width: 100%; height: 100%;"
              :src="'/onlyoffice/editor/' + currentTemplate.id + '?user_id=' + $parent.$parent.user.id + '&user_name=' + $parent.$parent.user.name"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <!-- !OnlyOffice Modal -->

  </div>
</template>

<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  export default {
    components: { Treeselect },
    props: ['id', 'project'],
    computed: {
      startPage() {
        if (this.currentPage < 4) {
          return 1;
        }
        if (this.currentPage == this.lastPage) {
          return this.startPage2;
        }

        if ((this.currentPage + 1) == this.lastPage) {
          return this.startPage2;
        }

        if ((this.currentPage + 2) == this.lastPage) {
          return this.startPage2;
        }
        return this.currentPage - 3;
      },
      startPage2(){
        if(this.lastPage > 6){
          return this.lastPage - 6;
        }
        if(this.lastPage > 5){
          return this.lastPage - 5;
        }
        if(this.lastPage > 4){
          return this.lastPage - 4;
        }
        if(this.lastPage > 3){
          return this.lastPage - 3;
        }
        if(this.lastPage > 2){
          return this.lastPage - 2;
        }
      },
      visiblePages() {
        let pages = [];
        let start = this.startPage;
        let end = Math.min(this.startPage + 6, this.lastPage);
        for (let i = start; i <= end; i++) {
          pages.push({
            name: i,
            active: i == this.currentPage
          });
        }
        return pages;
      },
      filteredRecords(){
        if(this.folders && this.folders.length > 0)
          return this.folders.filter((item) => item.parent_id === null)
      },
    },
    data () {
      return {
        // OnlyOffice данные
        onlyOfficeTitle: '',
        onlyOfficeKey: Date.now(),
        currentTemplate: null,
        // остальное
        link: null,
        link_path: null,
        fileInputKey: 0,
        searchQuery: '',
        currentPage: 1,
        lastPage: 1,
        firstPage: 1,
        timeout: null,
        perPage: 50,
        perPageList: [10, 25, 50, 100],
        templates: [],
        folders: [],
        recordform: new Form({
          id: null,
          name: null,
          description: null,
          file: null,
          folder_id: null
        }),
        editmode: false,
        changefile: false
      }
    },
    methods: {
      SuccessToast(){
        Toast.fire({
          icon: 'success',
          title: 'Успешно'
        });
      },
      ErrorToast(){
        Toast.fire({
          icon: 'error',
          title: 'Ошибка'
        });
      },
      viewRecord(template) {
        if(template.file.includes('.docx')){
          this.currentTemplate = template;
          this.onlyOfficeTitle = template.name;
          this.onlyOfficeKey = Date.now();
          $('#onlyOfficeModal').modal('show');
        }else if(template.file.includes('.pdf')){
          this.link = template.id
          this.link_path = template.file
          $('#showPDFModal').modal('show');
        }
      },
      editRecord(record){
        this.editmode = true;
        this.changefile = false;
        this.recordform.reset();
        this.recordform.id = record.id;
        this.recordform.name = record.name;
        if(record.folder)
          this.recordform.folder_id = record.folder.id;
        this.recordform.description = record.description;
        this.recordform.file = record.file;
        $('#addNewRecord').modal('show');
      },
      fileUpload(e){
        this.recordform.file = e.target.files[0];
      },
      newRecord(){
        this.editmode = false;
        this.changefile = true;
        this.recordform.reset();
        $('#addNewRecord').modal('show');
      },
      nextPage(){
        if(this.currentPage < this.lastPage){
          this.currentPage++;
          this.loadRecords();
        }
      },
      selectPage(number){
        this.currentPage = number;
        this.loadRecords();
      },
      prevPage(){
        if(this.currentPage > 1){
          this.currentPage--;
          this.loadRecords();
        }
      },
      search(){
        if(this.timeout)
          clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.$Progress.start();
          this.currentPage = 1;
          this.loadRecords();
          this.$Progress.finish();
        }, 500);

      },
      changePerPage(){
        this.currentPage = 1;
        this.loadRecords();
      },
      createRecord(){
        this.$Progress.start();
        const data = new FormData();
        data.append('name', this.recordform.name);
        data.append('description', this.recordform.description);
        data.append('folder_id', this.recordform.folder_id);
        data.append('file', this.recordform.file);
        axios.post('/api/project/'+this.id+'/template', data)
        .then((response)=>{
          $('#addNewRecord').modal('hide');
          this.SuccessToast();
          this.loadRecords();
          this.fileInputKey++;
          this.recordform.reset();
          this.$Progress.finish();
        })
        .catch(()=>{
          this.ErrorToast();
          this.$Progress.fail();
        })
      },
      updateRecord(){
        this.$Progress.start();
        const data = new FormData();
        data.append('name', this.recordform.name);
        data.append('description', this.recordform.description);
        data.append('folder_id', this.recordform.folder_id);
        data.append('file', this.recordform.file);
        data.append("_method", "put");
        axios.post('/api/project/'+this.id+'/template/'+this.recordform.id, data)
        .then((response) => {
          $('#addNewRecord').modal('hide');
          this.SuccessToast();
          this.loadRecords();
          this.fileInputKey++;
          this.editmode = false;
          this.changefile = false;
          this.recordform.reset();
          this.$Progress.finish();
        })
        .catch(() => {
          this.ErrorToast();
          this.$Progress.fail();
        });
      },
      deleteRecord(id){
        Swal.fire({
          title: 'Вы уверены?',
          text: "Это действие нельзя будет отменить",
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          cancelButtonText: 'Отмена',
          confirmButtonText: 'Да, удалить'
          }).then((result) => {
           if (result.value) {
            this.recordform.delete('/api/project/'+this.id+'/template/'+id).then(()=>{
              this.SuccessToast();
              this.loadRecords();
            }).catch((data)=> {
              this.ErrorToast();
            });
          }
        })
      },
      loadRecords(){
        axios.get('/api/project/'+this.id+'/template?page='+this.currentPage+'&search='+this.searchQuery+'&perPage='+this.perPage).then(({ data }) => {
          this.templates = data.data;
          this.lastPage = data.last_page;
        });
      },
      loadFolders(){
        axios.get('/api/project/'+this.id+'/folder').then(({ data }) => {
          this.folders = data;
        });
      }
    },
    created() {
      this.$Progress.start();
      this.loadRecords();
      this.loadFolders();
      this.$Progress.finish();
      window.Echo.private('templates')
                  .listen('TemplateUpdated', e => {
                    this.templates.forEach((item, i) => {
                      if(item.id === e.template.id){
                        this.templates[i].id = e.template.id;
                        this.templates[i].description = e.template.description;
                        this.templates[i].file = e.template.file;
                        this.templates[i].folder = e.template.folder;
                        this.templates[i].folder_id = e.template.folder_id;
                        this.templates[i].name = e.template.name;
                        this.templates[i].project_id = e.template.project_id;
                      }
                    });
                  })
    },
  }
</script>
